import { z } from 'zod'

export const accountTotalResponseSchema = z.object({
  id: z.string().guid(),
  accountId: z.string().guid(),
  balance: z.number(),
  source: z.string(),
  sourceId: z.string().guid().nullable(),
  date: z.coerce.date(),
  createdAt: z.coerce.date(),
})

export type AccountTotalResponseDto = z.infer<typeof accountTotalResponseSchema>
